<template>
    <button class='btn btn-primary btn-credicys' v-on:click='action'>
        <slot name='label'></slot>
    </button>
</template>

<script>
    export default {
        name: 'action-btn',
        methods: {
            action: function () {
                this.$emit('action')
            }
        },
    }
</script>

<style scoped>
    .btn-credicys {
        padding: 1em;
        border-radius: 2em;
        margin-bottom: 2em;
    }
</style>



// WEBPACK FOOTER //
// src/components/button/actionBtn.vue